// // import React from "react";
// // import { useNavigate } from "react-router-dom";
// // import { FaUserCircle } from "react-icons/fa";

// // const MobileSidebarLoggedOut = ({ isMenuOpen, menuRef }) => {
// //     const navigate = useNavigate();

// //     return (
// //         isMenuOpen && (
// //             <div
// //                 ref={menuRef}
// //                 className="md:hidden bg-white absolute top-16 left-0 w-3/4 h-[671px] z-10 shadow-lg"
// //             >
// //                 <div className="flex flex-col space-y-4 p-4 text-xl font-semibold text-gray-700">


// //                     <a
// //                         href="/login-signup"
// //                         className="flex items-center hover:text-indigo-500"
// //                         onClick={() => navigate("/login-signup")}
// //                     >
// //                         <FaUserCircle className="mr-2" />
// //                         Login Or Signup
// //                     </a>

// //                     <a href="/" className="hover:text-indigo-500">
// //                         Home
// //                     </a>
// //                     <a href="/product" className="hover:text-indigo-500 ">
// //                         Our Fleet
// //                     </a>
// //                     <a href="/offers" className="hover:text-indigo-500 ">
// //                         Offers
// //                     </a>
// //                     <a href="/franchise" className="hover:text-indigo-500">
// //                         Partner with us
// //                     </a>
// //                     <a href="/contact" className="hover:text-indigo-500 ">
// //                         Contact Us
// //                     </a>
// //                     <a href="/blog" className="hover:text-indigo-500">
// //                         Blog
// //                     </a>
// //                     <a href="/franchise" className="hover:text-indigo-500 ">
// //                         FAQ
// //                     </a>

// //                 </div>
// //             </div>
// //         )
// //     );
// // };

// // export default MobileSidebarLoggedOut;


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { FaUserCircle } from "react-icons/fa";

// const MobileSidebarLoggedOut = ({ isMenuOpen, menuRef }) => {
//     const navigate = useNavigate();

//     return (
//         isMenuOpen && (
//             <div
//                 ref={menuRef}
//                 className="md:hidden bg-white absolute top-16 left-0 w-3/4 h-[671px] z-10 shadow-lg border border-gray-300 rounded-lg"
//             >
//                 <div className="flex flex-col p-4 text-xl font-semibold text-gray-700">
//                     <a
//                         href="/login-signup"
//                         className="flex items-center hover:text-indigo-500 border-b border-gray-200 pb-2 "
//                         onClick={() => navigate("/login-signup")}
//                     >
//                         <FaUserCircle className="mr-2" />
//                         Login Or Signup
//                     </a>
//                     <a href="/" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
//                         Home
//                     </a>
//                     <a href="/product" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
//                         Our Fleet
//                     </a>
//                     <a href="/offers" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
//                         Offers
//                     </a>
//                     <a href="/franchise" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
//                         Partner with us
//                     </a>
//                     <a href="/contact" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
//                         Contact Us
//                     </a>
//                     <a href="/blog" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
//                         Blog
//                     </a>
//                     <a href="/franchise" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
//                         FAQ
//                     </a>
//                 </div>
//             </div>
//         ) 
//     );
// };

// export default MobileSidebarLoggedOut;


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { FaUserCircle, FaInstagram, FaLinkedin, FaYoutube , FaFacebook } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";

// const MobileSidebarLoggedOut = ({ isMenuOpen, menuRef }) => {
//     const navigate = useNavigate();

//     return (
//         isMenuOpen && (
//             <div
//                 ref={menuRef}
//                 className="md:hidden bg-white absolute top-12 left-0 w-3/4 h-[688px] z-10 shadow-lg border border-gray-300 rounded-lg"
//             >
//                 <div className="flex flex-col p-4 text-xl font-semibold text-gray-700">
//                     <a
//                         href="/login-signup"
//                         className="flex items-center hover:text-[#FF9630] border-b border-gray-200 pb-2 "
//                         onClick={() => navigate("/login-signup")}
//                     >
//                         <FaUserCircle className="mr-2" />
//                         Login Or Signup
//                     </a>
//                     <a href="/" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
//                         Home
//                     </a>
//                     <a href="/product" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
//                         Our Fleet
//                     </a>
//                     <a href="/offers" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
//                         Offers
//                     </a>
//                     <a href="/franchise" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
//                         Partner with us
//                     </a>
//                     <a href="/contact" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
//                         Contact Us
//                     </a>
//                     <a href="/blog" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
//                         Blog
//                     </a>
//                     <a href="/faq" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
//                         FAQ
//                     </a>
//                 </div>
//                 <div className="flex justify-center items-center space-x-8 mt-32 pb-4 px-4">
//                     <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
//                         <FaFacebook />
//                     </a>
//                     <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
//                         <FaInstagram />
//                     </a>
//                     <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
//                     <FaXTwitter />
//                     </a>
                   
//                     <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
//                     <FaLinkedin />
//                     </a>
//                     <a
//                         href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl" aria-label="YouTube">
//                         <FaYoutube />
//                     </a>

//                 </div>
//             </div>
//         )
//     );
// };

// export default MobileSidebarLoggedOut;

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserCircle, FaInstagram, FaLinkedin, FaYoutube, FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const MobileSidebarLoggedOut = ({ isMenuOpen, setIsMenuOpen, menuRef }) => {
  const navigate = useNavigate();

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false); // Close the sidebar
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen, setIsMenuOpen, menuRef]);

  if (!isMenuOpen) return null; // Prevent rendering if the menu is not open

  return (
    <div
      ref={menuRef}
      className="md:hidden bg-white absolute top-14 left-0 w-3/4 h-full z-10 shadow-lg border border-gray-300"
    >
      <div className="flex flex-col p-4 text-xl font-semibold text-gray-700">
        <a
          href="/login-signup"
          className="flex items-center hover:text-[#FF9630] border-b border-gray-200 pb-2"
          onClick={() => navigate("/login-signup")}
        >
          <FaUserCircle className="mr-2" />
          Login Or Signup
        </a>
        <a href="/" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
          Home
        </a>
        <a href="/product" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
          Our Fleet
        </a>
        <a href="/offers" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
          Offers
        </a>
        <a href="/franchise" className="hover:text-[#FF9630] border-b border-gray-200 pb-2 mt-4">
          Partner with us
        </a>
        <a href="/contact" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
          Contact Us
        </a>
        <a href="/blog" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
          Blog
        </a>
        <a href="/faq" className="hover:text-[#FF9630] text-gray-500 text-lg border-gray-200 pb-2 mt-4">
          FAQ
        </a>
      </div>
      <div className="flex justify-center items-center space-x-8 mt-56 pb-4 px-4">
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
          <FaFacebook />
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
          <FaInstagram />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
          <FaXTwitter />
        </a>
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#FF9630] text-2xl">
          <FaLinkedin />
        </a>
        <a
          href="https://youtube.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-500 hover:text-[#FF9630] text-2xl"
          aria-label="YouTube"
        >
          <FaYoutube />
        </a>
      </div>
    </div>
  );
};

export default MobileSidebarLoggedOut;
